import {  ListItem, styled } from '@mui/material';

export const CustomizedListItem = styled(ListItem)({
  fontWeight: 'bold',
  cursor: 'pointer',
})
